import { Main } from '@pages/nomadlife/Main';
import { CardInfo } from '@pages/nomadlife/CardInfo';
import {
  nomadLifePay,
  nomadLifePayFailed,
  nomadLifePaySuccess
} from '@root/constants/paths';
import CustomSuccess from '@root/components/CustomSuccess';
import CustomFailed from '@root/components/CustomFailed';
import { formPayData, getNomadLifeContentData } from '@root/constants/formData';

const { main } = getNomadLifeContentData();

export const getNomadLifePayRoutes = () => [
  {
    path: nomadLifePay(),
    element: (
      <Main
        mainContent={main}
        formData={formPayData}
        redirectPaths={{
          success: nomadLifePaySuccess,
          failed: nomadLifePayFailed
        }}
      >
        <CardInfo userData={undefined as never} />
      </Main>
    )
  },
  {
    path: nomadLifePaySuccess(),
    element: <CustomSuccess />
  },
  {
    path: nomadLifePayFailed(),
    element: <CustomFailed />
  }
];
